// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ed1E","field":"styles_field__31Rn9","fieldCol":"styles_fieldCol__2BmSQ","diffCol":"styles_diffCol__25p8C","diff":"styles_diff__P8jVR"};